import React from 'react';
import { translate } from 'components/Translation';
import { BodyS } from 'components/Typography/Typography';
import CustomConfirmationDialog from 'components/CustomConfirmationDialog/CustomConfirmationDialog';

interface ICannotDeleteProps {
	hideDialog: () => void;
}

const CannotDelete = (props: ICannotDeleteProps) => {
	return (
		<CustomConfirmationDialog
			isOpen
			hideDialog={props.hideDialog}
			isError
			header={<BodyS>{translate('active.services.delete.billing.account.no.contact.number')}</BodyS>}
		>
			<BodyS>{translate('active.services.add.billing.account.please.contact.omantel')}</BodyS>
		</CustomConfirmationDialog>
	);
};

export default CannotDelete;
